import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { HiAcademicCap } from "react-icons/hi";
 
<HiAcademicCap className="text-success display-4 mb-2" />
const Mision = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="mision-section bg-light py-5 "style={{ marginTop: "90px" }}>
      <div className="container text-center">
        <div className="mb-4" data-aos="fade-down">
          <HiAcademicCap className="text-success display-4 mb-2" />
          <h1 className="display-5 fw-bold text-success">Nuestra Misión</h1>
          <hr className="w-25 mx-auto border-2 border-success" />
        </div>

        <div className="row justify-content-center" data-aos="fade-up">
          <div className="col-md-10 col-lg-8">
            <p className="mt-4 text-secondary">
              En el Colegio Santo Tomás, nuestra misión es formar personas íntegras, solidarias y comprometidas con una sociedad más justa y humana. 
              Promovemos el desarrollo académico, espiritual y emocional de nuestros estudiantes, fomentando el pensamiento crítico, la creatividad y el respeto por la diversidad.
            </p>
            <p className="mt-4 text-secondary">
              Nos inspiramos en los valores cristianos para guiar el crecimiento personal y comunitario, cultivando una educación basada en el amor, el diálogo y la responsabilidad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mision;
